import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  deleteResDataAction,
  editStatusResDataAction,
  editStatusResDataR,
  saveLogin,
  saveResDataAction,
} from "../../redux/slices/mainDataSlice";
import Swal from "sweetalert2";

export default function AllRestaurants() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const isAuth = useSelector((state) => state.main.isAuthenticated);
  const restaurantsData = useSelector((state) => state.main.data);
  const adminData = useSelector((state) => state.main.adminData);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedResId, setSelectedResId] = useState(null);
  const [resImage, setResImage] = useState(null);
  const [resSrcImage, setResSrcImage] = useState(null);
  const [resName, setResName] = useState(null);
  const [resTheme, setResTheme] = useState(0);
  const [resUsername, setResUsername] = useState("");
  const [resPhone, setResPhone] = useState("");
  const [resPassword, setResPassword] = useState("");
  const [resEndDate, setResEndDate] = useState("");

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isAuth) {
      const storedUserCredentials = JSON.parse(
        localStorage.getItem("userCredentials"),
      );
      if (storedUserCredentials) {
        dispatch(saveLogin(storedUserCredentials));
      } else {
        navigate("/");
      }
    }
  }, [isAuth]);

  const [filter, setFilter] = useState("all");
  const [filterText, setFilterText] = useState("");

  const handlerEditRes = (id) => {
    setSelectedResId(id);
    const resSelected = restaurantsData.filter((res) => res.id === id)?.[0];
    const admin = adminData?.filter((user) => user.id_res == resSelected.id)[0];
    setResImage(
      `https://api.atharalfarasha.com/public/logo/${resSelected.logo}`,
    );
    setResTheme(parseInt(resSelected.theme));
    setResName(resSelected.res_name);
    setResUsername(admin?.username);
    setResPhone(resSelected.phone_n);
    setResEndDate(resSelected.end_date);
    setIsEditing(false);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setResImage(reader.result);
      setResSrcImage(file);
    };
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const toggleEditing = () => {
    setIsEditing((prev) => !prev);
  };

  const handleSave = () => {
    const data = {
      id: parseInt(selectedResId),
      res_name: resName,
      theme: resTheme,
      username: resUsername,
      phone: resPhone,
      password: resPassword,
      end_date: resEndDate == "Invalid Date" ? "" : resEndDate,
    };
    console.log(resSrcImage);
    console.log(resImage);

    dispatch(
      saveResDataAction({
        data,
        image: resSrcImage,
      }),
    ).then(() => {
      setResImage(``);
      setResSrcImage(null);
      setSelectedResId(null);
    });
    setIsEditing(false);
  };
  const handleToggle = (id, status) => {
    dispatch(editStatusResDataR({ id, status }));
    dispatch(editStatusResDataAction({ id, status }));
  };
  const filteredRestaurants = restaurantsData?.filter((school) => {
    if (filter === "all") return true;
    if (filter === "1000")
      return (
        school.theme === "3" ||
        school.theme === "31" ||
        school.theme === "32" ||
        school.theme === "33"
      );
    if (filter === "400") return school.theme === "2";
    if (filter === "200") return school.theme === "1";
    if (filter === "100") return school.theme === "5";
    return false;
  });

  const filteredRes2 = filteredRestaurants?.filter((res) => {
    return res.res_name.toLowerCase().includes(filterText); // Filter by name
  });
  const handleFilterChange = (event) => {
    const searchText = event.target.value.toLowerCase();
    setFilterText(searchText);
  };
  const handlerDeleteRes = (id) => {
    Swal.fire({
      title: "هل متاكد من حذف المطعم ؟",
      text: "بمجرد الضغط علي نعم لا تستطيع استعاده بيانات المطعم",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "لا",
      confirmButtonText: "نعم",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "تم الحذف بنجاح",
          text: "تم حذف المطعم بنجاح",
          icon: "success",
        });
        dispatch(deleteResDataAction(id));
      }
    });
  };
  return (
    <div className="allRes-page">
      <Header
        text={`المطاعـــم المشتركة (${restaurantsData?.length})`}
        isAll={true}
      />
      <div className="box" data-aos="fade-in">
        <div className="search">
          <div className="search-box">
            <input
              type="text"
              name=""
              id=""
              placeholder="اكتب اسم المطعم"
              onChange={handleFilterChange}
            />
            <div className="icon">
              <i className="fa-solid fa-magnifying-glass"></i>
            </div>
          </div>
        </div>
        <div className="head-title">
          <div className="filters">
            <div
              className={`filter ${filter === "all" ? "active" : ""}`}
              onClick={() => setFilter("all")}
            >
              all
            </div>
            <div
              className={`filter ${filter === "1000" ? "active" : ""}`}
              onClick={() => setFilter("1000")}
            >
              1000
            </div>
            <div
              className={`filter ${filter === "400" ? "active" : ""}`}
              onClick={() => setFilter("400")}
            >
              400
            </div>
            <div
              className={`filter ${filter === "200" ? "active" : ""}`}
              onClick={() => setFilter("200")}
            >
              200
            </div>
            <div
              className={`filter ${filter === "100" ? "active" : ""}`}
              onClick={() => setFilter("100")}
            >
              100
            </div>
          </div>
        </div>
        <div className="restaurants">
          {filteredRes2?.map((res) => (
            <div key={res.id} className={`restaurant `}>
              <div className="info">
                <div className="group-one">
                  <div
                    className="extra"
                    onClick={() => handlerDeleteRes(res?.id)}
                    style={{ color: "#c83232", marginRight: "10px" }}
                  >
                    <i className="fa-solid fa-trash-can"></i>
                  </div>
                  <div
                    className="extra"
                    onClick={() => handlerEditRes(res?.id)}
                  >
                    <i className="fa-solid fa-gear"></i>
                  </div>
                  <div className="toggle-switch">
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={res.status == "0" ? true : false}
                        onChange={() =>
                          handleToggle(res.id, res.status == 0 ? 1 : 0)
                        }
                      />
                      <span className="slider round">
                        {res.status == 0 ? (
                          <span className="slider-text active">ON</span>
                        ) : (
                          <span className="slider-text">OFF</span>
                        )}
                      </span>
                    </label>
                  </div>
                </div>
                <div className="group-two">
                  <div className="theme">
                    {res.theme == "1" ? (
                      <>200</>
                    ) : res.theme == "2" ? (
                      <>400</>
                    ) : res.theme == "3" ||
                      res.theme === "31" ||
                      res.theme === "32" ||
                      res.theme === "33" ? (
                      <>1000</>
                    ) : res.theme == "5" ? (
                      <>100</>
                    ) : (
                      <i class="fas fa-exclamation-triangle fa-fw"></i>
                    )}
                  </div>
                  <div className="name">
                    {res.res_name} [
                    <Link
                      to={`https://res.atharalfarasha.com/?resturant=${res.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {res.id}
                    </Link>
                    ]
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {selectedResId != null && (
        <div className="res-info">
          <div
            className="layout"
            data-aos="fade-in"
            onClick={() => {
              setSelectedResId(null);
              setResImage("");
              setResSrcImage(null);
            }}
          ></div>
          <div className="info-box" data-aos="zoom-in">
            {restaurantsData
              .filter((res) => res.id === selectedResId)
              .map((resSelected) => (
                <React.Fragment key={resSelected.id}>
                  <div className="logo">
                    <img src={resImage} alt="" />
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      id="upload"
                      onChange={handleImageUpload}
                    />
                    <label htmlFor="upload" className="edit-icon">
                      <i className="fa-solid fa-plus"></i>
                    </label>
                  </div>
                  <div className="group">
                    <div className="edit-icon" onClick={toggleEditing}>
                      <i
                        className={`fa-solid ${
                          isEditing ? "fa-save" : "fa-pen"
                        }`}
                      ></i>
                    </div>
                    <input
                      type="text"
                      onChange={(e) => setResName(e.target.value)}
                      value={resName}
                      disabled={!isEditing}
                    />
                  </div>
                  <div className="theme-group">
                    <div className="title">نوع النظــــــــام</div>
                    <div className="themes">
                      <div
                        className={`theme ${resTheme == "5" ? "active" : ""}`}
                        onClick={() => setResTheme("5")}
                      >
                        100
                      </div>
                      <div
                        className={`theme ${resTheme == "1" ? "active" : ""}`}
                        onClick={() => setResTheme("1")}
                      >
                        200
                      </div>
                      <div
                        className={`theme ${resTheme == "2" ? "active" : ""}`}
                        onClick={() => setResTheme("2")}
                      >
                        400
                      </div>
                      <div
                        className={`theme ${resTheme == "3" ? "active" : ""}`}
                        onClick={() => setResTheme("3")}
                      >
                        1000
                      </div>
                    </div>
                  </div>
                  <div className="group2">
                    <div className="title">أسم المستخدم</div>
                    <div className="group">
                      <div className="edit-icon" onClick={toggleEditing}>
                        <i
                          className={`fa-solid ${
                            isEditing ? "fa-save" : "fa-pen"
                          }`}
                        ></i>
                      </div>
                      <input
                        type="text"
                        onChange={(e) => setResUsername(e.target.value)}
                        value={resUsername}
                        disabled={!isEditing}
                      />
                    </div>
                  </div>
                  <div className="group2">
                    <div className="title">رقم الهاتف</div>
                    <div className="group">
                      <div className="edit-icon" onClick={toggleEditing}>
                        <i
                          className={`fa-solid ${
                            isEditing ? "fa-save" : "fa-pen"
                          }`}
                        ></i>
                      </div>
                      <input
                        type="text"
                        onChange={(e) => setResPhone(e.target.value)}
                        value={resPhone}
                        disabled={!isEditing}
                      />
                    </div>
                  </div>
                  <div className="group2">
                    <div className="title">كلمه المرور</div>
                    <div className="group">
                      <div className="edit-icon" onClick={toggleEditing}>
                        <i
                          className={`fa-solid ${
                            isEditing ? "fa-save" : "fa-pen"
                          }`}
                        ></i>
                      </div>
                      <input
                        type="text"
                        onChange={(e) => setResPassword(e.target.value)}
                        disabled={!isEditing}
                      />
                    </div>
                  </div>
                  <div className="end-date">
                    <div className="title">تاريــــــخ انتهاء</div>
                    <input
                      type="date"
                      min={new Date().toISOString().split("T")[0]}
                      value={
                        resEndDate && resEndDate != "0000-00-00"
                          ? new Date(resEndDate).toISOString().split("T")[0]
                          : ""
                      }
                      onChange={(e) => setResEndDate(e.target.value)}
                    />
                  </div>
                  <div className="actions">
                    <Link
                      to={`https://admin.atharalfarasha.com/?username=${resUsername}&password=${
                        adminData?.filter(
                          (user) => user.id_res == resSelected.id,
                        )[0]?.password
                      }`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="menu"
                    >
                      <i className="fa-solid fa-utensils"></i>
                    </Link>

                    <div className="save-btn" onClick={handleSave}>
                      حفظ
                    </div>
                  </div>
                </React.Fragment>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
